/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useState } from "react";

import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";

import { colors } from "@dotnet/telematics-design-system";

import TextLink from "../../../../../../TextLink/TextLink";
import { TEXT_LINK_SIZES } from "../../../../../../TextLink/types";
import ContentBox from "../../../components/ContentBox/ContentBox";
import { useStyles } from "../../styles";
import ChangePasswordDialog from "./ChangePasswordDialog/ChangePasswordDialog";

const ChangePassword = () => {
  const { t } = useTranslation();

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOpenChangePasswordDialog = () => {
    setIsDialogOpen(true);
  };

  const { contentBoxInnerDiv, settingPlaceholder, changePswContentBox } =
    useStyles({ colors });

  return (
    <div css={css(changePswContentBox)}>
      <ContentBox title={t("Password##password")}>
        <div css={css(contentBoxInnerDiv)}>
          <div css={css(settingPlaceholder)}>
            <Typography variant="body2Medium">
              {t("Password##account password")}
            </Typography>
          </div>
          <TextLink
            size={TEXT_LINK_SIZES.Normal}
            onClick={handleOpenChangePasswordDialog}
            data-testid="change-password-text-link"
          >
            {t("Password##change")}
          </TextLink>
        </div>
      </ContentBox>

      <ChangePasswordDialog
        isOpen={isDialogOpen}
        closeDialog={() => setIsDialogOpen(false)}
      />
    </div>
  );
};

export default ChangePassword;
